import { Close, Popup as KitPopup } from "lola-framework-ui-test";
import type { JSX } from "react";
import { flavorClassName } from "../constants";
import { useStore } from "../store/globalState";

export interface PopupProps {
  children: JSX.Element;
  visible?: boolean;
  onClose: () => void;
  className?: string;
  showCloseBtn?: boolean;
}

export const Popup: React.FC<PopupProps> = ({
  visible,
  onClose,
  children,
  className = "",
  showCloseBtn = true,
}) => {
  const { theme } = useStore();
  const { footerColor } = theme.whiteView;

  return (
    <KitPopup
      visible={visible}
      onClose={onClose}
      className={`${flavorClassName} ${className}`.trim()}
      showCloseBtn={showCloseBtn}
      CloseIcon={
        <Close
          size={24}
          className="close-popup-icon flavor-c-icon close-icon"
          onClick={onClose}
          colors={[footerColor, footerColor]}
        />
      }
    >
      {children}
    </KitPopup>
  );
};
